import { ImageSourceSetData } from "./ImageSourceSet";
import { SNSData, SNSInfo } from "./SNSInfo";

import { PageVisibility } from "../../utils/PageVisibility";

export enum Smoking {
  None = "None",
  Allow = "Allow",
  Separate = "Separate",
  NotAllow = "NotAllow",
}

export interface SonicFacilityData {
  id: string;
  name: string;
  status: PageVisibility;
  kana?: string;
  imgs?: ImageSourceSetData[];
  map?: string;
  prefecture?: string;
  address?: string;
  tel?: string;
  introduction?: string;
  businessDays?: string;
  hostEvents?: string;
  foodService?: string;
  price?: string;
  reservation?: string;
  seats?: string;
  officialSite?: string;
  sns?: SNSData;
  smoking?: Smoking;
  access?: string;
  machines?: string;
  owner?: {
    id: string;
    name: string;
    email: string;
  };
  facility_types: Array<string>;
  traits: Array<string>;
  price_status?: string;
  seating_capacity_max?: number;
  seating_capacity_text?: string;
  select_review?: string;
}

export class SonicFacility implements SonicFacilityData {
  id: string;
  name: string;
  status: PageVisibility;
  kana?: string;
  imgs?: ImageSourceSetData[];
  map?: string;
  prefecture?: string;
  address?: string;
  tel?: string;
  introduction?: string;
  businessDays?: string;
  hostEvents?: string;
  foodService?: string;
  price?: string;
  reservation?: string;
  seats?: string;
  officialSite?: string;
  sns?: SNSData;
  smoking?: Smoking;
  access?: string;
  machines?: string;
  owner?: {
    id: string;
    name: string;
    email: string;
  };
  facility_types: Array<string>;
  traits: Array<string>;
  price_status?: string;
  seating_capacity_max?: number;
  seating_capacity_text?: string;
  select_review?: string;

  constructor(
    id: string,
    name: string,
    status: PageVisibility,
    kana?: string,
    imgs?: ImageSourceSetData[],
    map?: string,
    prefecture?: string,
    address?: string,
    tel?: string,
    introduction?: string,
    businessDays?: string,
    hostEvents?: string,
    foodService?: string,
    price?: string,
    reservation?: string,
    seats?: string,
    officialSite?: string,
    twitter?: string,
    instagram?: string,
    facebook?: string,
    youtube?: string,
    smoking?: Smoking,
    access?: string,
    machines?: string,
    owner?: {
      id: string;
      name: string;
      email: string;
    },
    facility_types?: Array<string>,
    traits?: Array<string>,
    price_status?: string,
    seating_capacity_max?: number,
    seating_capacity_text?: string,
    select_review?: string
  ) {
    this.id = id;
    this.name = name;
    this.status = status;
    this.kana = kana;
    this.imgs = imgs;
    this.map = map;
    this.prefecture = prefecture;
    this.address = address;
    this.tel = tel;
    this.introduction = introduction;
    this.businessDays = businessDays;
    this.hostEvents = hostEvents;
    this.foodService = foodService;
    this.price = price;
    this.reservation = reservation;
    this.seats = seats;
    this.officialSite = officialSite;
    this.sns = new SNSInfo(twitter, undefined, instagram, facebook, youtube);
    this.smoking = smoking;
    this.access = access;
    this.machines = machines;
    this.owner = owner;
    this.facility_types = facility_types ?? [];
    this.traits = traits ?? [];
    this.price_status = price_status;
    this.seating_capacity_max = seating_capacity_max;
    this.seating_capacity_text = seating_capacity_text;
    this.select_review = select_review;
  }

  static serializeFacility = (item: SonicFacilityData) => {
    return {
      ...item,
      sns: { ...item.sns },
    };
  };

  static parseFromAPIResponse(item: any) {
    return new SonicFacility(
      item.id,
      item.name,
      item.status,
      item.kana,
      item.imgs,
      item.map,
      item.prefecture,
      item.address,
      item.tel,
      item.introduction,
      item.business_days,
      item.host_events,
      item.food_service,
      item.price,
      item.reservation,
      item.seats,
      item.official_site,
      item.sns.twitter,
      item.sns.instagram,
      item.sns.facebook,
      item.sns.youtube,
      item.smoking,
      item.access,
      item.machines,
      item.owner,
      item.facility_types,
      item.traits,
      item.price_status,
      item.seating_capacity_max,
      item.seating_capacity_text,
      item.select_review
    );
  }
}
